import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {
    startTime: null,
    endTime: null,
    elapsedTime: 0,
    isTimerRunning: false,
};

const timerReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'START_TIMER':
            if (state.isTimerRunning) {
                return state;
            }
            return {
                ...state,
                startTime: action.payload.timestamp,
                endTime: null,
                elapsedTime: 0,
                isTimerRunning: true,
            };
        case 'CONTINUE_TIMER':
            return {
                ...state,
                isTimerRunning: true,
            };
        case 'STOP_TIMER': {
            if (!state.isTimerRunning || !state.startTime) {
                return state;
            }
            const elapsedTime = action.payload.timestamp - state.startTime;
            return {
                ...state,
                endTime: action.payload.timestamp,
                elapsedTime: elapsedTime,
                isTimerRunning: false,
            };
        }
        case 'RESET_TIMER':
            return {
                ...initialState,
            };
        default:
            return state;
    }
};

export default persistReducer(
    {
        key: 'surgeryTimerKey',
        storage: storage,
    },
    timerReducer
);
